<template>
  <div>
    <a-row :gutter="[16, 16]">
      <a-col v-for="item in resultList" :key="item.id" :span="8">
        <div class="user-card" @click="toDetail(item.id)">
          <div class="avatorImg">
            <MediaWrap class="audio-wrap" :url="getUrl(item)"></MediaWrap>
          </div>
          <div class="infos-wrap">
            <div class="name">{{ item.name }}</div>
            <div class="description-wrap">简介：{{ item.introduction }}</div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    resultList: Array
  },
  methods: {
    getUrl(item) {
      if (item.fileVo.length > 0) {
        return item.fileVo[0].url;
      } else {
        return require('@/assets/images/人才智库人才.png');
      }
    },
    // 跳转详情
    toDetail(id) {
      this.$router.push({ name: 'talentDetail', query: { id } });
    }
  }
}
</script>